import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { Spacer } from "../../layout";

export const FormLabelFeedback = styled(Spacer)`
    &:not(:empty) {
        margin-top: ${sizes.xSmall}px;
    }
`;
